import { render, staticRenderFns } from "./ComponentHistoryBill.vue?vue&type=template&id=601fb144"
import script from "./ComponentHistoryBill.vue?vue&type=script&lang=js"
export * from "./ComponentHistoryBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports